import { useCallback, useEffect } from "react";

/**
 * Hook that shows a browser warning when the user tries to leave the page with unsaved changes
 * @param hasUnsavedChanges - Boolean indicating if there are unsaved changes that would be lost
 */
export const useWarnIfUnsavedChanges = (hasUnsavedChanges: boolean) => {
  const handleBeforeUnload = useCallback(
    (event: BeforeUnloadEvent) => {
      if (!hasUnsavedChanges) {
        return;
      }

      event.preventDefault();
      return "";
    },
    [hasUnsavedChanges]
  );

  useEffect(() => {
    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [handleBeforeUnload]);
};
